import { render } from "./UniversalPdfImageRow.vue?vue&type=template&id=6310c94e&scoped=true&ts=true"
import script from "./UniversalPdfImageRow.vue?vue&type=script&lang=ts"
export * from "./UniversalPdfImageRow.vue?vue&type=script&lang=ts"

import "./UniversalPdfImageRow.vue?vue&type=style&index=0&id=6310c94e&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6310c94e"]])

export default __exports__